import { useCallback, useEffect, useRef, useState } from 'react'
import { Platform } from 'react-native'
import { PB_SERVER_ADDR } from '@/lib/config'
import { log } from '@/lib/logger'

const CLIENT_SHA = process.env.EXPO_PUBLIC_GIT_SHA
const POLL_INTERVAL = 5 * 60 * 1000
const DEBOUNCE_INTERVAL = 60 * 1000

export function useWebAppUpdates() {
    const [updateAvailable, setUpdateAvailable] = useState(false)
    const lastCheckRef = useRef(0)

    const checkForUpdate = useCallback(async () => {
        const now = Date.now()
        if (now - lastCheckRef.current < DEBOUNCE_INTERVAL) return
        lastCheckRef.current = now

        try {
            const res = await fetch(`${PB_SERVER_ADDR}/api/version`)
            const data = await res.json()
            if (data.version && data.version !== CLIENT_SHA) {
                log.info(`Web update available: server=${data.version} client=${CLIENT_SHA}`)
                setUpdateAvailable(true)
            }
        } catch {
            // best-effort — silently swallow fetch errors
        }
    }, [])

    useEffect(() => {
        if (__DEV__ || Platform.OS !== 'web' || !CLIENT_SHA) return

        const timerId = setInterval(checkForUpdate, POLL_INTERVAL)

        const onVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                checkForUpdate()
            }
        }
        document.addEventListener('visibilitychange', onVisibilityChange)

        return () => {
            clearInterval(timerId)
            document.removeEventListener('visibilitychange', onVisibilityChange)
        }
    }, [checkForUpdate])

    return { updateAvailable }
}
